import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "../ui/Icons";
import "./Page.css";

export function PageHero({ eyebrow, title, lead, chips = [] }) {
  const reduce = useReducedMotion();
  const anim = (delay) => ({
    initial: reduce ? false : { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, ease: [0.2, 0.7, 0.2, 1], delay },
  });
  return (
    <div className="phero">
      <RouterLink to="/" className="phero__back">
        <ArrowLeft /> Back to home
      </RouterLink>
      <motion.span className="eyebrow" {...anim(0.05)}>
        {eyebrow}
      </motion.span>
      <motion.h1 className="display" {...anim(0.12)}>
        {title}
      </motion.h1>
      <motion.p className="lead" {...anim(0.2)}>
        {lead}
      </motion.p>
      {chips.length > 0 && (
        <motion.div className="phero__meta" {...anim(0.28)}>
          {chips.map((c) => (
            <span key={c} className="chip">
              {c}
            </span>
          ))}
        </motion.div>
      )}
    </div>
  );
}

export function CtaBanner({ title = "Ready to see it on your cameras?", text }) {
  const navigate = useNavigate();
  return (
    <div className="card cta-banner">
      <div>
        <h2 className="h2">{title}</h2>
        <p>
          {text ||
            "Book a demo and we will walk through your sites, cameras and the hardware that fits."}
        </p>
      </div>
      <button type="button" className="btn btn-primary" onClick={() => navigate("/contact")}>
        Book a demo <ArrowRight className="i" />
      </button>
    </div>
  );
}

export function Timeline({ items }) {
  return (
    <ol className="timeline">
      {items.map((it, i) => (
        <li key={it.title} className="tl__item">
          <span className="tl__idx">0{i + 1}</span>
          <div>
            <h3 className="tl__title">{it.title}</h3>
            <p className="tl__text">{it.content}</p>
          </div>
          {it.outputs && (
            <div className="tl__side">
              <span className="mono">Outputs</span>
              <div className="chips">
                {it.outputs.map((o) => (
                  <span key={o} className="chip">
                    {o}
                  </span>
                ))}
              </div>
            </div>
          )}
        </li>
      ))}
    </ol>
  );
}
